export * from './useAsync';
export { default as useSelectable, type Selectable } from './useSelectable';
export { default as useModal } from './useModal';
export { default as useTraceProps } from './useTraceProps';

export function isGuid(value: string | null | undefined): value is Guid {
    if (!value) {
        return false;
    }
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegex.test(value);
}
